export default __webpack_public_path__ + "static/media/253.2af44487.png";